<script>
import Layout from '@layouts/main'
import { hmdaMethods } from '@state/helpers'
// import constant from '@constants/constant'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'

export default {
  components: { Layout, HmdaHeader },
  data() {
    return {
      showSpinner: false,
      project: {
        name: '',
        description: '',
      },
      // constant,
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        { text: 'Create Project', active: true },
      ],
      customer: null,
      user: null,
    }
  },

  mounted() {
    this.getSelectedCustomer().then((res) => {
      this.customer = res
    })

    this.getSelectedUser().then((res) => {
      this.user = res
    })
  },

  methods: {
    ...hmdaMethods,
    goBack() {
      this.$router.go(-1)
    },

    showError(msg) {
      this.$refs.msg
        .showAsync(
          msg || 'An unexpected error occured while creating project',
          'Alert',
          'Ok'
        )
        .then(() => {})
    },

    async onClickCreateProject() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }

        this.showSpinner = true

        const payload = {
          projectName: this.project.name,
          description: this.project.description,
          customerId: this.customer ? this.customer.value : 0,
          assignedTo: this.user ? this.user.value : 0,
        }
        this.createProject(payload)
          .then((success) => {
            const projectId = success.id || 0
            this.$router.push({
              name: 'hmda-project-details',
              params: { id: projectId, name: this.project.name },
            })
          })
          .finally(() => {
            this.showSpinner = false
          })
      })
    },
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <HmdaHeader :crumbs="breadcrumbs" />
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <div class="body--wrapper mt-1 bg-white container">
      <BaseTitleMenu heade-title="Create Project" />
      <b-form @submit.prevent="onClickCreateProject">
        <b-row class="mb-2">
          <b-col cols="12">
            <div class="d-block mb-2">
              <div>
                <BaseEInputText
                  v-model="project.name"
                  v-validate="{
                    required: true,
                  }"
                  name="name"
                  data-vv-as="Name"
                  mark-required
                  maxlength="100"
                  placeholder="Project Name"
                  label-content="Project Name"
                />
                <div class="error"> {{ errors.first('name') }} </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12">
            <div class="d-block mb-2">
              <div>
                <BaseTextarea
                  v-model="project.description"
                  label-content="Description (Optional)"
                  maxlength="250"
                ></BaseTextarea>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseEButton class="mr-3 ml-0" type="submit">
              Create
            </BaseEButton>
            <BaseEButton variant="cancel" @click="goBack">Back</BaseEButton>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </Layout>
</template>
